// Set up for multiple ppd sections on a page

document.querySelectorAll('.productV7')?.forEach(section => {

    /************
     Product Swiper
     ************/

        // thumbnail mobile swiper
    let mobileSwiper = new Swiper(section.querySelector('.productV7ThumbnailsMobileSwiper'), {
            slidesPerView: 4.5,
            spaceBetween: 10
        });

// setup product swiper
    let productImages = new Swiper(section.querySelector('.productV7Swiper'), {
        thumbs: {
            swiper: mobileSwiper
        }
    });

// thumbnail
    section.querySelectorAll(".productV7ThumbnailsItem").forEach(function (element) {
        element.addEventListener("click", function () {
            // determine index
            let index;
            if (this.parentElement.classList.contains('swiper-slide')) {
                index = getElIndex(this.parentElement);
            } else {
                index = getElIndex(this);
            }

            // change active slide
            productImages.slideTo(index);
        });
    });

    /****************
     Product Dropdown
     *****************/

    section.querySelectorAll('.productV7FaqQuestion').forEach((el) => {
        el.addEventListener('click', function () {
            this.classList.toggle('active');
        })
    })

    /****************
     Purchase Options
     ****************/

    section.querySelectorAll('.productV7Purchase').forEach(el => {
        el.addEventListener('click', function () {
            // update staus on inputs
            if (this.classList.contains('active')) return;
            section.querySelector('.productV7Purchase.active')?.classList.remove('active');
            this.classList.add('active');
            // update the active variant and info
            updateInfo();
        })
    })

    /**************
     Product Update
     ***************/

    function updateInfo() {
        // update atc
        if (section.querySelector('.productV7Purchase.active').classList.contains('subscribe')) {
            section.querySelectorAll('.productV7ATCPrice')?.forEach(el => el.style.display = 'inline');
            section.querySelectorAll('.productV7ATCCompare')?.forEach(el => el.classList.remove('subBundle'));
        } else {
            section.querySelectorAll('.productV7ATCPrice')?.forEach(el => el.style.display = 'none');
            section.querySelectorAll('.productV7ATCCompare')?.forEach(el => el.classList.add('subBundle'));
        }
    }

    // initial run
    updateInfo();

    /**************
     Product ATC
     ***************/

    section.querySelectorAll(".productATC").forEach(atc => {
        atc.addEventListener("click", async function () {
            this.classList.add("loading");

            // check subscription
            const subscription = section.querySelector('.productV7Purchase.active').classList.contains('subscribe');
            let subscriptionID = section.querySelector('.productV7PurchaseInfoSubItemInput:checked')?.value || null;

            let formData = {
                items: [{
                    quantity: 1,
                    id: parseInt(this.dataset.id),
                    // if subscription is chosen, use active id
                    selling_plan: subscription ? subscriptionID : null
                }]
            };

            // add product
            await addProduct(formData);

            // open cart
            await openCart();

            this.classList.remove("loading");
        });
    })
})

// sticky atc
document.querySelectorAll('.productStickyATC')?.forEach((el, index) => {
    // make sure only one exists
    if (index > 0) el.remove();
})

if (document.querySelector('.productStickyATC')) {
    const pdpBottom = document.querySelector('.productV7').offsetHeight;
    const stickyAtc = document.querySelector('.productStickyATC');
    let scrollPosition = 0;

    window.addEventListener('scroll', () => {
        if (window.scrollY - 200 < pdpBottom) {
            stickyAtc.classList.remove('active');
            return;
        }
        if (window.scrollY < scrollPosition) {
            stickyAtc.classList.add('active');
        } else {
            stickyAtc.classList.remove('active');
        }
        scrollPosition = window.scrollY;
    })
}